import { Component } from '@angular/core';

@Component({
  selector: 'app-environmental-protection-portal',
  templateUrl: './environmental-protection-portal.component.html',
  standalone: false,
})
export class EnvironmentalProtectionPortalComponent {}
